import { defineStore } from "pinia";
import { useMemberStore } from "@modelStores/member-store";
import { useAdminStore } from "@modelStores/admin-store";

export type UserType = "Member" | "Admin" | "Guest" | null;

export interface EnvironmentState {
  currentUserType: UserType;
  currentMemberId: number | null;
  currentAdminId: number | null;
  isEnvironmentInited: boolean;
}

export interface SetEnvironmentParams {
  userType: UserType;
  memberId?: number | null;
  adminId?: number | null;
}

export const useEnvironmentStore = defineStore("environment", {
  state: (): EnvironmentState => ({
    currentUserType: null,
    currentMemberId: null,
    currentAdminId: null,
    isEnvironmentInited: false,
  }),

  getters: {
    apiScope: (state): string | null => {
      return state.currentUserType?.toLowerCase() || null;
    },

    isReady: (state): boolean => {
      return state.isEnvironmentInited && state.currentUserType !== null;
    },

    currentMember: (state) => {
      if (!state.currentMemberId) return null;

      const memberStore = useMemberStore();
      return memberStore.find(state.currentMemberId);
    },

    currentAdmin: (state) => {
      if (!state.currentAdminId) return null;

      const adminStore = useAdminStore();
      return adminStore.find(state.currentAdminId);
    },
  },

  actions: {
    setEnvironment(params: SetEnvironmentParams): void {
      this.currentUserType = params.userType;
      this.currentMemberId = params.memberId ?? null;
      this.currentAdminId = params.adminId ?? null;
      this.isEnvironmentInited = true;
    },

    clearEnvironment(): void {
      this.currentUserType = null;
      this.currentMemberId = null;
      this.currentAdminId = null;
      this.isEnvironmentInited = false;
    },

    setIsEnvironmentInited(value: boolean): void {
      this.isEnvironmentInited = value;
    },
  },
});
